const URLS = {
    // MY PRESCRIPTIONS
    GET_MY_SAVED_PRESCRIPTIONS:
        '/wcs/resources/store/{storeId}/wcs/prescription/user/@self?nocache={noCache}',
    GET_CONTACT_ATTRIBUTES:
        '/wcs/resources/store/{storeId}/catalog/{catalogId}/contactlenses/byId/{productId}',
    ADD_TO_CART: '/LCOrderItemAddContactLensesCmd',
    // DOWNLOAD PRESCRIPTION FILE
    DOWNLOAD_PRESCRIPTION_FILE:
        '/wcs/resources/store/{storeId}/wcs/prescription/download/{fileName}?nocache={noCache}',
    GET_ESPOT: '/wcs/resources/store/##storeId##/espot/',
};

export default URLS;
